// extracted by mini-css-extract-plugin
export default {"link":"styles_link__PUGew","ContainerPrimary":"styles_ContainerPrimary__FMYx5","paper":"styles_paper__ecaJ5","titleLogin":"styles_titleLogin__p3dn9"};